import { create } from 'zustand';

import { UpsellContext, UpsellFlow, UpsellOffer, UpsellUsage } from '@/entities/pricing';

import { createModalStore } from '@/shared/lib/modal';
import { ResultDownloadKind } from '@/shared/lib/resultDownload';

export type UpsellHighlight = 'lipsync' | 'subtitles';

type UpsellModalData = {
  context?: UpsellContext;
  downloadKind?: ResultDownloadKind;
  flow?: UpsellFlow;
  highlight?: UpsellHighlight;
  primary?: UpsellOffer;
  secondary?: UpsellOffer;
  usage?: UpsellUsage;
};

const initialState: UpsellModalData = {
  context: undefined,
  downloadKind: undefined,
  flow: undefined,
  highlight: undefined,
  primary: undefined,
  secondary: undefined,
  usage: undefined,
};

export const useUpsellModalStore = createModalStore<UpsellModalData>(initialState, false);

type UpsellTriggerStore = {
  homeVisits: number;
};

export const useUpsellTriggerStore = create<UpsellTriggerStore>(() => ({ homeVisits: 0 }));
